module.exports = function (value) {
    return value === 'normal' ? '400' : value === 'bold' ? '700' : value;
};



//////////////////
// WEBPACK FOOTER
// ./~/postcss-minify-font-values/lib/minify-weight.js
// module id = 1627
// module chunks = 0